module.exports = __webpack_public_path__ + "static/media/times-circle.8ba8b286.svg";